import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { slot: "content" }
const _hoisted_4 = { class: "input-grid" }
const _hoisted_5 = { slot: "content" }
const _hoisted_6 = {
  key: 0,
  class: "spin ion-text-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src", "onClick"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 2,
  class: "ion-text-right"
}
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        (_ctx.isFromAB4)
          ? (_openBlock(), _createBlock(_component_ion_toolbar, {
              key: 0,
              color: "primary",
              style: {"--min-height":"24px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      slot: "icon-only",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.professionName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_ctx.isImageBot)
            ? (_openBlock(), _createBlock(_component_ion_accordion_group, {
                key: 1,
                value: "input"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_accordion, { value: "input" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        color: "primary",
                        lines: "full",
                        slot: "header"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => [
                              (_ctx.imageBotTargetProfession)
                                ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.imageBotTargetProfession.name), 1))
                                : (_openBlock(), _createElementBlock("h2", _hoisted_2, "AI images"))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              (_ctx.professionId)
                                ? (_openBlock(), _createBlock(_component_ion_button, {
                                    key: 0,
                                    class: "no-text-transform",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openProfessionModal(_ctx.professionId)), ["stop"]))
                                  }, {
                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                      _createTextVNode("Details")
                                    ])),
                                    _: 1,
                                    __: [22]
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_button, {
                                class: "no-text-transform",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.prefillDemoDataForImageBot()), ["stop"]))
                              }, {
                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                  _createTextVNode("Demo")
                                ])),
                                _: 1,
                                __: [23]
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_ion_toolbar, { style: {"padding":"2px"} }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.photoOfA,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userInputs.photoOfA) = $event)),
                                label: "Photo of a",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.wearing,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userInputs.wearing) = $event)),
                                label: "Wearing",
                                placeholder: "e.g. office suit",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.holding,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userInputs.holding) = $event)),
                                label: "Holding",
                                placeholder: "e.g. iPad",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.engaging,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userInputs.engaging) = $event)),
                                label: "Engaging",
                                placeholder: "e.g. with client",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.gesture,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userInputs.gesture) = $event)),
                                label: "Gesture",
                                placeholder: "e.g. talking",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.workingIn,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.userInputs.workingIn) = $event)),
                                label: "Working in",
                                placeholder: "e.g. meeting room",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.facialExp,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userInputs.facialExp) = $event)),
                                label: "Expression",
                                placeholder: "e.g. smile",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ion_input, {
                                class: "compact-input",
                                modelValue: _ctx.userInputs.lookingAt,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userInputs.lookingAt) = $event)),
                                label: "Looking at",
                                placeholder: "e.g. camera",
                                "label-placement": "floating",
                                fill: "outline",
                                "clear-input": true
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          size: "small",
                          expand: "block",
                          class: "no-text-transform",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendPromptToBot('image'))),
                          disabled: _ctx.waitingBotResp
                        }, {
                          default: _withCtx(() => [
                            _cache[24] || (_cache[24] = _createTextVNode(" Generate Image ")),
                            _createVNode(_component_ion_icon, {
                              slot: "end",
                              icon: _ctx.arrowForward
                            }, null, 8, ["icon"])
                          ]),
                          _: 1,
                          __: [24]
                        }, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_accordion_group, {
                key: 2,
                value: "input"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_accordion, { value: "input" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        color: "primary",
                        lines: "full",
                        slot: "header"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                slot: "icon-only",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closeModal()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                              _createElementVNode("h2", null, "Generate CV bullet points / CL claims", -1)
                            ])),
                            _: 1,
                            __: [25]
                          }),
                          (_ctx.user.isAdmin)
                            ? (_openBlock(), _createBlock(_component_ion_buttons, {
                                key: 0,
                                slot: "end"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_button, {
                                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.prefillDemoData()), ["stop"]))
                                  }, {
                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                      _createTextVNode("Demo")
                                    ])),
                                    _: 1,
                                    __: [26]
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_ion_toolbar, { style: {"padding-left":"5px","padding-right":"5px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_textarea, {
                              modelValue: _ctx.userInputs.workExps,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.userInputs.workExps) = $event)),
                              label: "Your CV / work experiences",
                              "label-placement": "floating",
                              fill: "outline",
                              style: {"margin-top":"10px","margin-bottom":"10px"},
                              rows: 6
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_textarea, {
                              modelValue: _ctx.userInputs.jd,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.userInputs.jd) = $event)),
                              label: "JD (Job Description)",
                              "label-placement": "floating",
                              fill: "outline",
                              rows: 6
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, { size: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  expand: "block",
                                  class: "no-text-transform",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sendCVBulletPointsReq())),
                                  disabled: _ctx.waitingBotResp
                                }, {
                                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createTextVNode("CV bullet points")
                                  ])),
                                  _: 1,
                                  __: [27]
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_col, { size: "6" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_button, {
                                  expand: "block",
                                  class: "no-text-transform",
                                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sendCLClaimsReq())),
                                  disabled: _ctx.waitingBotResp
                                }, {
                                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                                    _createTextVNode("CL claims")
                                  ])),
                                  _: 1,
                                  __: [28]
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { ref: "contentEl" }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, {
          class: "ion-no-padding",
          fixed: ""
        }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", null, [
                    _createElementVNode("img", {
                      style: {"width":"100px"},
                      src: require('@/assets/logo.png')
                    }, null, 8, _hoisted_7)
                  ]),
                  _createVNode(_component_ion_spinner)
                ]))
              : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages.slice(_ctx.messages.length-50, _ctx.messages.length), (msg) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        lines: "none",
                        key: msg.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, {
                            color: msg.fromUser ? 'tertiary' : 'light',
                            slot: msg.fromUser ? 'end' : 'start',
                            style: {"padding":"8px","font-size":"16px"}
                          }, {
                            default: _withCtx(() => [
                              (_ctx.isImageMessage(msg.content))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: msg.content,
                                    style: {"max-width":"100%","border-radius":"4px","cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.openImageModal(msg.content, _ctx.getPreviousUserMessage(msg)))
                                  }, null, 8, _hoisted_8))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "message",
                                    innerHTML: _ctx.parseMsg(msg.content)
                                  }, null, 8, _hoisted_9)),
                              (msg.content != 'The bot encountered an unexpected issue.')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (!msg.fromUser)
                                      ? (_openBlock(), _createBlock(_component_ion_button, {
                                          key: 0,
                                          size: "small",
                                          class: "no-text-transform",
                                          color: "success",
                                          onClick: ($event: any) => (_ctx.sendBotMsgToWhatsApp(msg.content))
                                        }, {
                                          default: _withCtx(() => [
                                            _cache[29] || (_cache[29] = _createTextVNode(" Send to my WhatsApp ")),
                                            _createVNode(_component_ion_icon, {
                                              slot: "end",
                                              icon: _ctx.send
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 2,
                                          __: [29]
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["color", "slot"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (_ctx.latestBotResp)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 0,
                          lines: "none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card, {
                              color: 'light',
                              slot: "start",
                              style: {"padding":"8px","font-size":"16px"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: "message",
                                  innerHTML: _ctx.parseMsg(_ctx.latestBotResp)
                                }, null, 8, _hoisted_11)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  lines: "none",
                  style: {"padding-top":"5px","--padding-start":"0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_textarea, {
                      fill: "outline",
                      modelValue: _ctx.userInputs.custom,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userInputs.custom) = $event)),
                      shape: "round",
                      disabled: _ctx.waitingBotResp,
                      onKeyup: _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.sendMsg()), ["exact","prevent"]), ["enter"])),
                      "auto-grow": true,
                      style: {"max-height":"50vh","overflow":"scroll"}
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode(_component_ion_buttons, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          color: "primary",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sendMsg())),
                          disabled: !_ctx.userInputs.custom
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: _ctx.send
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}